import styled, { css } from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { borderRadius, borderWidth } from "../../../design-system/tokens/borders";
import { typographyMixin } from "../../../design-system/tokens/typography";

export { EmptyHint } from "../KgInspectorTablesTab/KgInspectorTablesTab.styles";

export const TabRoot = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SectionBlock = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${spacing[4]};
  padding: ${spacing[4]} ${spacing[3]} ${spacing[3]};
  border-bottom: ${borderWidth[1]} solid ${rawColors.stroke[200]};
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
`;

export const IconSlot = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: ${rawColors.text.lowEmphasis};
  flex-shrink: 0;
`;

export const SectionTitle = styled.span`
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.highEmphasis};
`;

export const DescriptionBody = styled.p`
  margin: 0;
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.highEmphasis};
`;

export const DataSourcesSection = styled.section<{ $isOpen?: boolean }>`
  border-bottom: ${borderWidth[1]} solid ${rawColors.stroke[200]};

  ${({ $isOpen }) =>
    $isOpen
      ? css`
          display: flex;
          flex-direction: column;
          gap: ${spacing[4]};
          padding: ${spacing[4]} ${spacing[3]} ${spacing[3]};
        `
      : css`
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: ${spacing[3]};
          min-height: 50px;
          padding: ${spacing[3]};
          cursor: pointer;

          &:hover {
            background-color: ${rawColors.structural[50]};
          }
        `}
`;

export const DataSourcesHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const LabelGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  min-width: 0;
`;

export const CountBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px ${spacing[2]};
  background-color: ${rawColors.structural[100]};
  border: ${borderWidth[1]} solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius.sm};
  ${typographyMixin("overline", 3)}
  color: ${rawColors.text.mediumEmphasis};
`;

export const Chevron = styled.span<{ $isOpen?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: ${rawColors.text.mediumEmphasis};
  flex-shrink: 0;
  transition: transform 0.2s ease;
  transform: rotate(${({ $isOpen }) => ($isOpen ? "180deg" : "0deg")});
`;

export const LinkRowStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[2]};
`;
